module.exports = __webpack_public_path__ + "img/GO_04.4a692c96.png";